import { User } from "lucide-react";

interface ProfilePictureProps {
  profilePictureUrl?: string;
  firstName?: string;
  lastName?: string;
  className?: string;
  iconSize?: number;
  variant?: "default" | "black";
}

export const ProfilePicture = ({
  profilePictureUrl,
  firstName,
  lastName,
  className = "h-full w-full",
  iconSize,
  variant = "default",
}: ProfilePictureProps) => {
  const hasPicture = !!profilePictureUrl;
  const altText =
    firstName && lastName
      ? `Profile picture of ${firstName} ${lastName}`
      : "Profile picture";

  // Calculate icon size based on container if not provided
  // For h-32 w-32 (128px), use 72px icon
  // For h-12 w-12 (48px), use ~28px icon
  // Default to 72 for larger sizes
  const defaultIconSize = iconSize || 72;

  if (hasPicture) {
    return (
      <img
        className={`${className} rounded-full object-cover`}
        src={profilePictureUrl}
        alt={altText}
      />
    );
  }

  const isOnPrimary = variant === "black";
  const placeholderClasses = isOnPrimary
    ? ""
    : "bg-soluud-primary-light ring-2 ring-soluud-primary/10";
  const iconClasses = isOnPrimary ? "text-black" : "text-soluud-primary";

  return (
    <div
      className={`${className} ${placeholderClasses} flex items-center justify-center rounded-full`}
      role="img"
      aria-label="Profile picture placeholder"
    >
      <User size={defaultIconSize} className={iconClasses} aria-hidden="true" />
    </div>
  );
};
